import { Observable, firstValueFrom } from "rxjs";
import { map } from "rxjs";
import { environment } from "src/environments/environment";
import { LoginService } from "src/app/login/login.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class QuickbooksIntegrationService {
  constructor(
    public _http: HttpClient,
    public loginService: LoginService,
  ) {}

  getAccounts(realmId: string): Promise<any> {
    if (realmId !== null && realmId !== undefined) {
      const url = `${environment.apiUrl}/integration/quickbooks/${realmId}/accounts`;
      return this._http.get(url).toPromise();
    } else {
      console.log("Error: realmId is null");
    }
  }

  getAccountsByCompanyId(company_id): any {
    const url = `${environment.apiUrl}/integration/quickbooks/accounts/${company_id}`;
    return this._http.get(url).pipe(map((acc: any) => acc.accounts));
  }

  getVendorsByCompanyId(company_id): any {
    const url = `${environment.apiUrl}/integration/quickbooks/vendors/${company_id}`;
    return this._http.get(url).pipe(map((v: any) => v.vendors));
  }

  getConnectedWorkspaces(): Promise<any> {
    const url = `${environment.apiUrl}/integration/quickbooks/connected-workspaces`;
    return this._http.get(url).toPromise();
  }

  disconnectWorkspace(linkUuid: string): Promise<any> {
    const url = `${environment.apiUrl}/integration/quickbooks/disconnect-workspace`;
    const payload = { linkUuid };
    return this._http.post(url, payload).toPromise();
  }

  updateConnectedWorkspace(
    linkUuid: string,
    accountId: string,
    accountName: string,
    accountPath: string,
  ): Promise<any> {
    const url = `${environment.apiUrl}/integration/quickbooks/update-connected-workspace`;
    const payload = { linkUuid, accountId, accountName, accountPath };
    return this._http.post(url, payload).toPromise();
  }

  getPurchases(workspace_id: any): Observable<any> {
    return this._http.get(
      `${environment.apiUrl}/integration/quickbooks/get-purchases/${workspace_id}`,
    );
  }

  syncPurchases(workspace_id: any): Observable<any> {
    return this._http.get(
      `${environment.apiUrl}/integration/quickbooks/sync/${workspace_id}`,
    );
  }

  hasQbdIntegration(workspace_id: any): Observable<any> {
    return this._http.get(
      `${environment.apiUrl}/integration/quickbooks/has-qbd/${workspace_id}`,
    );
  }

  refreshCache(workspaceId: number): Observable<any> {
    return this._http.get(
      `${environment.apiUrl}/integration/quickbooks/refresh-cache/${workspaceId}`,
    );
  }

  refreshTrackingClassFlag(workspaceUuid: string): Observable<any> {
    return this._http.get(
      `${environment.apiUrl}/integration/quickbooks/refresh-preferences/${workspaceUuid}`,
    );
  }

  retrieveClasses(workspaceId: any): Promise<any> {
    return firstValueFrom(
      this._http.get(
        `${environment.apiUrl}/integration/quickbooks/classes/${workspaceId}`,
      ),
    );
  }

  addAccountToCompany(companyId: any, account: any): Promise<any> {
    return this._http
      .post(
        `${environment.apiUrl}/integration/quickbooks/company-accounts/${companyId}`,
        account,
      )
      .toPromise();
  }

  getCompaniesAccounts(): Promise<any> {
    return this._http
      .get(`${environment.apiUrl}/integration/quickbooks/company-accounts`)
      .toPromise();
  }

  deleteCompanyAccountLink(linkUuid) {
    return this._http
      .delete(
        `${environment.apiUrl}/integration/quickbooks/company-account-link/${linkUuid}`,
      )
      .toPromise();
  }

  getCompanyAccounts(companyId: any): Promise<any> {
    return this._http
      .get(
        `${environment.apiUrl}/integration/quickbooks/company-accounts/${companyId}`,
      )
      .toPromise();
  }
}
